import { default as axiosModule } from "axios";
import Cookies from "js-cookie";
import { createServerErrorResponse } from "../types/server-api/errors";

// const API_URL = "http://localhost:3333/api";
// const API_URL = "https://eclisse-backend.herokuapp.com/api"
const API_URL = "https://is-backend.eclisse-eshop.sk/api"

const axios = axiosModule.create({
  baseURL: API_URL,
});

axios.interceptors.request.use((config) => {
  const token = Cookies.get("_token");
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    throw createServerErrorResponse(error);
  }
);

export default axios;
